module.exports = __webpack_public_path__ + "img/shi1.3e68a6dd.png";